
(function($) {
	function showErrorToast(message, duration = 5000) {
		const toast = document.getElementById('toast');

		if (!toast) return; // Exit if toast element doesn't exist
		// Reset by removing all animation classes
		toast.classList.remove('toast-visible', 'toast-hidden');

		// Force reflow to reset animations (critical!)
		void toast.offsetWidth;

		// Set message and trigger bounce-in
		toast.textContent = message;
		toast.classList.add('toast-visible');

		// Auto-hide with bounce-out
		setTimeout(() => {
			toast.classList.replace('toast-visible', 'toast-hidden');
		}, duration);
	}
	$(document).ready(function() {

		$('#flex_step1').on('change', function () {
			try {
				mcs_triggerSpinner();

				var $lists_final   = $(this).parents("form").find('#js-parts-body');
				const part_filter  = $(this).val();
				const part_name    = $(this).data('part_name');
				const part_file_id = $(this).data('part_file_id');
				const part_sep     = $(this).data('part_sep');

				var ajax_data = {
					action:       'mcs_ajax_get_part_details',
					part_file_id: part_file_id,
					part_sep:     part_sep,
					part_filter:  part_filter,
					nonce:        mcs_data.partsNonce,
				};

				$lists_final.html('');
				$.ajax({
					cache:   false,
					timeout: 3000,
					url:     mcs_data.ajax_url,
					type:    'get',
					data:    ajax_data
				})
				.done( function( response ){

					try {
						if( response.data === undefined ){
							return;
						}

						if( response.success !== true ) {
							const msg_error = '<p class="msg_error has-error"><b class="input-group-addon">' + response.data + '</p>';
							$lists_final.append( msg_error );
							return;
						}
						var item_class_dim = 'items--one-dim';

						$.each( response.data, function( length_size, matching_parts ){
							$.each( matching_parts, function( index, details ){

								var part__cart1 = document.createElement( 'div' );
								part__cart1.className = 'product__overlay product__overlay--hide js-inline-product__overlay';

								var part__cart2 = document.createElement( 'h2' );
								part__cart2.className = 'product__overlay__title';
								var part__cart2_text = document.createTextNode(  mcs_data.addedToOrder );
								part__cart2.appendChild( part__cart2_text );

								var part__cart3 = document.createElement( 'i' );
								part__cart3.className = 'glyphicon glyphicon-ok btn btn-success';

								part__cart1.appendChild( part__cart2 );
								part__cart1.appendChild( part__cart3 );

								var part__row = document.createElement( 'tr' );
								part__row.className = 'parts_table__item parts-data-row' + item_class_dim;

								var ref_wrap      = document.createElement('td');
								var price_wrap    = document.createElement( 'td' );
								var price_italics = document.createElement('span');

								var result_before = document.createTextNode( '[ ' );
								var result_after  = document.createTextNode( ' ]' );
								var prod_ref      = document.createTextNode( details.ref );

								const price = details.price;
								var price_text = '';
								if ( price === null) {
									throw new Error("Price is null");
								}
								// detect if price has a euro sign
								if ( price.indexOf( '€' ) !== -1 ) {
									price_text = price;
								} else {
									price_text = price + ' €';
								}
								var prod_price    = document.createTextNode( price_text );


								// ref
								ref_wrap.appendChild( prod_ref );
								part__row.appendChild( ref_wrap );

								// properties
								if ( details.properties !== undefined ) {
									// for each details.properties, add a new element

									for ( var i = 0; i < details.properties.length; i++ ) {
										const prop = details.properties[i];
										if ( prop.length > 0 ) {
											var prop_wrap = document.createElement('td');
											prop_wrap.className = 'parts_table__dim2';
											prop_wrap.classList.add( 'parts_table__dim2--' + i );
											const prop_text = document.createTextNode( prop );
											prop_wrap.appendChild( prop_text );
											part__row.appendChild( prop_wrap );
										}
									}

								}
								// price
								price_italics.appendChild( prod_price );
								price_wrap.appendChild( result_before );
								price_wrap.appendChild( price_italics );
								price_wrap.appendChild( result_after );
								part__row.appendChild( price_wrap );

								var has_stock = details.price == 0 ? 0 : 1;
								var order_btn = build_order_btn(
									has_stock,     // qty stock
									'0',           // qty reserved
									details.ref,   // reference
									part_name + details.ref, // name
									price,         // price
									'0',           // discount
									price,         // price discounted
									'small',       // size
									1              // in transit
								);

								part__row.appendChild( order_btn );
								part__row.appendChild( part__cart1 );
								//part_wrap.appendChild( div__row );
								$lists_final.append( part__row );
							});
						});
					} catch (error) {
						console.error('Error in AJAX response:', error);
						showErrorToast('Failed to load data. Please contact us.'); // Optional: Show user feedback
					}
				} )

				.always( function(){
					mcs_hideSpinner();
				})
				.fail( function( jqXHR, textStatus, errorThrown ){
					mcs_hideSpinner();
					console.log( 'The following error occured: ' + textStatus, errorThrown );
				});
			} catch (error) {
				mcs_hideSpinner();
				console.error('Error:', error);
				showErrorToast('Failed to load data. Please contact us.'); // Optional: Show user feedback
			} finally {
				mcs_hideSpinner();
			}
		});
	});
})(jQuery);